"use client";

import React, { createContext, useContext } from "react";

import { FeatureFlagMap as FlagMap, FeatureFlagKey as FeatureKey } from "@/lib/feature-flags/flags";

import { useAuth } from "@/dashboard/contexts/auth-context";
import { useFeatureFlagsQuery } from "@/dashboard/hooks/feature-flags/use-feature-flags-query";

interface Ctx {
  flags: FlagMap | null;
  loading: boolean;
  hasFeature: (k: FeatureKey) => boolean;
}
const FeatureContext = createContext<Ctx>({} as Ctx);

export default function FeatureProvider({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();

  const { data, isLoading } = useFeatureFlagsQuery(isAuthenticated);

  const value: Ctx = {
    flags: data ?? null,
    loading: isLoading,
    hasFeature: k => !!data?.[k],
  };

  return <FeatureContext.Provider value={value}>{children}</FeatureContext.Provider>;
}

export const useFeatureFlags = () => {
  const ctx = useContext(FeatureContext);
  if (!ctx) {
    throw new Error("useFeatureFlags must be used within a FeatureProvider");
  }
  return ctx;
};
